import React from "react";

export const WorkspaceSection = ({ title, icon: Icon, action, children, testId }) => (
  <section className="cjms-section" data-testid={testId}>
    <header className="cjms-section-header"><h2>{Icon && <Icon size={15} />}{title}</h2>{action}</header>
    {children}
  </section>
);